import moment from 'moment-timezone'

$(function() {
    const $timeEl = document.querySelector('.js-location-time');

    function loadTime(timeEl) {
        let timeZone = timeEl.dataset.timezone,
            locTime = moment().tz(timeZone).format('h:mm A');
        timeEl.innerHTML = locTime;
    }

    if ($timeEl) {
        setInterval(loadTime, 1000, $timeEl);
    }
});